module.exports = __webpack_public_path__ + "angular/components/directives/ebAccountDropdown-2055831e.html";


//////////////////
// WEBPACK FOOTER
// ./source/angular/components/admin/directives/ebAccountDropdown.html
// module id = 35
// module chunks = 0